import React from 'react';
import PropTypes from 'prop-types';
import Numeral from 'numeral';
import moment from 'moment';

const MlsSearchData = ({ ...props }) => {
  MlsSearchData.propTypes = {
    property: PropTypes.object
  };

  let formattedCityState = '';
  const { city = '', stateOrProvince = '', postalCode = '', address1 = '' } = props.property.address;

  if (city) {
    formattedCityState = `${formattedCityState ? `${formattedCityState}, ` : ''}${city}`;
  }

  if (stateOrProvince) {
    formattedCityState = `${formattedCityState ? `${formattedCityState}, ` : ''}${stateOrProvince}`;
  }

  if (postalCode) {
    formattedCityState = `${formattedCityState ? `${formattedCityState} ` : ''}${postalCode}`;
  }

  return (
    <React.Fragment>
      <div className='property-container'>
        <div className='property-image' >
          <img src={props.property.imageUrl} />
        </div>
        <div className='property-info'>
          {address1 && <span>{address1}</span>}
          {formattedCityState && <span>{formattedCityState}</span>}
          <span>
            {`$${Numeral(props.property.price).format('0,0')}`}
            {props.property.listingStatus ? ' - ' : ''}
            <strong>
              {props.property.listingStatus || ''}
            </strong>
          </span>

          <span>{`${props.property.bedrooms ? `${props.property.bedrooms} Bd ` : ''}${props.property.baths ? `${props.property.baths} Ba ` : ''}${props.property.buildingSize || ''} ${props.property.livingAreaUnits || ''}`}</span>
          <span>{`${props.property.listingDate ? `Listed: ${moment(props.property.listingDate).format('MM/DD/YY')}` : ''}`}</span>
          <span>{`${props.property.listingExpirationDate ? `Expr: ${moment(props.property.listingExpirationDate).format('MM/DD/YY')}` : ''}`}</span>

          <span>
            <strong>{`${props.property.listingOfficeName ? `Courtesy of ${props.property.listingOfficeName}` : ''}`}</strong>
            <span className='text-primary'>{`MLS# ${props.property.mlsListingId}`}</span>
            <span>
              <strong>{`${props.property.listingAgentName ? ` Agent: ${props.property.listingAgentName}` : ''}`}</strong>
            </span>
            <span>
              {props.property.listingAgentPhoneNumber}
            </span>
          </span>
        </div>
      </div>
    </React.Fragment>
  );
};
export default MlsSearchData;
